import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { HttpsRequestInterceptor } from './core/interceptors/http-request.interceptor';

const maskConfig: Partial<NgxMaskConfig> = {
  thousandSeparator: '.',
  allowNegativeNumbers: false,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([HttpsRequestInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideEnvironmentNgxMask(maskConfig),
    provideOAuthClient(),
  ],
};
